export default "__VITE_ASSET__DMzcu8oC__"